import { render, staticRenderFns } from "./OrderFormQuick.vue?vue&type=template&id=8bced6ae&"
import script from "./OrderFormQuick.vue?vue&type=script&lang=js&"
export * from "./OrderFormQuick.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormQuick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports